<template>
  <Modal title="Filtros" size="md" :is-open="isOpen" @close="onClose">
    <FilterCategoryList :filters="filters" />
    <template #buttons>
      <ButtonSecondary label="Limpar" @click="clearFiltersAndCloseModal" />
      <ButtonPrimary label="Aplicar filtros" @click="applyFilters" />
    </template>
  </Modal>
</template>

<script lang="ts">
import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
import {
  Modal,
  ButtonPrimary,
  ButtonSecondary
} from '@warrenbrasil/nebraska-web';
import { FilterCategoryList } from '../FilterCategoryList';
import { IFilterCategory } from '../../../../services/types/models/IFilters';

@Component({
  components: {
    FilterCategoryList,
    Modal,
    ButtonPrimary,
    ButtonSecondary
  }
})
export default class FiltersModal extends Vue {
  @Prop({ type: Boolean, default: false })
  readonly isOpen!: boolean;

  @Prop({ type: Array, default: () => [] })
  public filters!: IFilterCategory[];

  beforeUpdate() {
    for (const filterOption of this.filters) {
      if (filterOption.filters && filterOption.selectedOption) {
        filterOption.modalSelectedOption = filterOption.selectedOption;
      } else if (filterOption.subCategories) {
        for (const subCategoriesOption of filterOption.subCategories) {
          if (subCategoriesOption.selectedOption)
            subCategoriesOption.modalSelectedOption =
              subCategoriesOption.selectedOption;
        }
      }
    }
  }

  @Emit('apply-filters')
  public applyFilters() {
    this.onClose();
  }

  @Emit('clear-filters')
  public clearFiltersAndCloseModal() {
    for (const filterOption of this.filters) {
      if (filterOption.filters) {
        filterOption.applied = false;
        filterOption.quickSelectedOption = '';
        delete filterOption.selectedOption;
        delete filterOption.modalSelectedOption;
      } else if (filterOption.subCategories) {
        for (const subCategoriesOption of filterOption.subCategories) {
          subCategoriesOption.applied = false;
          delete subCategoriesOption.selectedOption;
          delete subCategoriesOption.modalSelectedOption;
        }
      }
    }
    this.onClose();
  }

  @Emit('on-close')
  onClose() {}
}
</script>
<style lang="less" scoped>
::v-deep .modal-buttons {
  gap: @size-spacing-x300;
  padding: @size-spacing-x500 @size-spacing-x1000;
  background: @background-secondary;
}

::v-deep .button--container {
  flex: 1;
}
</style>
